import { ERROR_MESSAGES, ERROR_TYPES, RIVER_ERROR_TYPES } from '../../../../lib/constants/errors';

export const getErrorMessage = (
  errorId: string,
  t: (descriptor: object, values?: object) => string
) => {
  switch (errorId) {
    case RIVER_ERROR_TYPES.INVALID_IBAN:
      return t({id: ERROR_MESSAGES.INVALID_IBAN})
    case RIVER_ERROR_TYPES.INVALID_ACCOUNT:
      return t({id: ERROR_MESSAGES.INVALID_ACCOUNT})
    case ERROR_TYPES.NOT_ENOUGH:
      return t({id: ERROR_MESSAGES.NOT_ENOUGH})
    default:
      return t({id: ERROR_MESSAGES.OTHER})
  }
}